import { render, staticRenderFns } from "./UserMescanMetabolismStatistics.vue?vue&type=template&id=87d775ba&scoped=true"
import script from "./UserMescanMetabolismStatistics.vue?vue&type=script&lang=js"
export * from "./UserMescanMetabolismStatistics.vue?vue&type=script&lang=js"
import style0 from "./UserMescanMetabolismStatistics.vue?vue&type=style&index=0&id=87d775ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d775ba",
  null
  
)

export default component.exports